module.exports = __webpack_public_path__ + "static/22-96d8307772c355c3afff63bb0bdb2d34.mp4";